import React, { useState } from 'react';
import {
  InputAdornment,
  ThemeProvider,
  Link,
  Box,
} from '@mui/material';
import { Email } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { resetPassword as resetPasswordApi } from '../DataService';
import { theme } from '../styles/theme/theme';
import {
  AuthPageContainer,
  AuthFormCard,
  AuthFormContainer,
  AuthNavContainer,
  AuthPageTitle,
  AuthSubtitle,
  AuthErrorMessage,
  AuthSuccessMessage,
  AuthTextField,
  AuthGradientButton,
} from '../styles/components';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await resetPasswordApi({ Email: email });
      setSuccess(true);
    } catch (err: any) {
      setError(err?.message || 'Failed to process request.');
    }
    setLoading(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <AuthPageContainer>
        <AuthFormCard elevation={6}>
          <AuthPageTitle variant="h5">
            Forgot Password
          </AuthPageTitle>
          
          {!success ? (
            <>
              <AuthSubtitle variant="body2">
                Enter your email address and we'll send you instructions to reset your password.
              </AuthSubtitle>

              <Box component="form" onSubmit={handleSubmit}>
                <AuthFormContainer>
                  <AuthTextField
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email color="primary" />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {error && (
                    <AuthErrorMessage>
                      {error}
                    </AuthErrorMessage>
                  )}

                  <AuthGradientButton
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Reset Password'}
                  </AuthGradientButton>
                </AuthFormContainer>
              </Box>
            </>
          ) : (
            <>
              <AuthSuccessMessage>
                Password reset instructions have been sent to your email.
              </AuthSuccessMessage>

              <AuthGradientButton
                fullWidth
                variant="contained"
                onClick={() => navigate('/sign-in')}
              >
                Return to Sign In
              </AuthGradientButton>
            </>
          )}

          <AuthNavContainer>
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/sign-in')}
              sx={{
                color: 'primary.main',
                '&:hover': {
                  color: 'primary.dark',
                },
              }}
            >
              Remember your password? Sign In
            </Link>
          </AuthNavContainer>
        </AuthFormCard>
      </AuthPageContainer>
    </ThemeProvider>
  );
};

export default ForgotPassword; 